import { useState } from 'react';
import { Menu } from 'lucide-react';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { SidebarContent } from '@/components/layout/Sidebar';
import { TopFilterBar } from '@/components/layout/TopFilterBar';
import { PoweredBy } from '@/components/common/PoweredBy';
import { SharitiMark } from '@/components/common/SharitiLogo';

export const AppShell = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="app-bg min-h-screen">
      <div className="flex">
        {/* Desktop sidebar */}
        <aside className="sticky top-0 hidden h-screen w-[268px] shrink-0 glass border-r lg:block">
          <SidebarContent />
        </aside>

        <div className="flex min-h-screen w-full min-w-0 flex-col">
          {/* Mobile top bar */}
          <div className="flex items-center justify-between border-b glass px-4 py-2.5 lg:hidden">
            <Sheet open={open} onOpenChange={setOpen}>
              <SheetTrigger asChild>
                <button className="flex h-9 w-9 items-center justify-center rounded-xl border bg-card" data-testid="mobile-menu-button">
                  <Menu className="h-5 w-5" />
                </button>
              </SheetTrigger>
              <SheetContent side="left" className="w-[280px] p-0">
                <SidebarContent onNavigate={() => setOpen(false)} />
              </SheetContent>
            </Sheet>
            <span className="flex items-center gap-2"><SharitiMark className="h-6 w-6" /><span className="font-display text-sm font-bold">SHARITI</span></span>
            <span className="w-9" />
          </div>

          <TopFilterBar />

          <main className="flex-1 px-4 py-6 sm:px-6 lg:px-8">
            <div className="mx-auto w-full max-w-[1440px] fade-up">{children}</div>
          </main>

          <footer className="flex items-center justify-center border-t px-6 py-4 lg:hidden">
            <PoweredBy />
          </footer>
        </div>
      </div>
    </div>
  );
};
